import { useNavigate, NavigateOptions, To } from 'react-router-dom';

type CustomNavigate = {
  (to: To | number, options?: NavigateOptions & { clearHistory?: boolean }): void;
  getHistoryDepth: () => number;
};

let historyDepth = 0;

const useCustomNavigate = (): CustomNavigate => {
  const navigate = useNavigate();

  const customNavigate = ((to: To | number, options?: NavigateOptions & { clearHistory?: boolean }) => {
    if (typeof to === 'number') {
      historyDepth = Math.max(0, historyDepth - 1);
      navigate(to);
    } else {
      if (options?.clearHistory) {
        historyDepth = 0;
        window.history.replaceState(null, '', window.location.href);
      } else {
        historyDepth += 1;
      }

      const { clearHistory, ...validOptions } = options || {};
      navigate(to, validOptions);
    }
  }) as CustomNavigate;

  customNavigate.getHistoryDepth = () => historyDepth;

  return customNavigate;
};

export default useCustomNavigate;
